import { createHeaders } from '@atlassian/csm-ui-components';
import { getFiltersQuery, serialiseFiltersQueryToSearchParams } from '../../common/filters';
import { API_GATEWAY_BASE_URL } from '../../utils';
import { isNotExcludedOwner } from '../../common/utils';
export const fetchConversations = async ({
  csmHubId,
  cursor,
  filters
}) => {
  const headers = createHeaders();
  const queryString = serialiseFiltersQueryToSearchParams(getFiltersQuery(filters));
  if (cursor) {
    queryString.set('cursor', cursor);
  }
  const baseUrl = `${API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/${csmHubId}/conversations`;
  return fetch(`${baseUrl}?${queryString}`, {
    method: 'GET',
    headers
  }).then(response => response.json()).then(data => {
    const conversations = data.items.filter(isNotExcludedOwner);
    const error = 'errorMessage' in data ? data : undefined;
    return {
      conversations,
      hasNext: data.hasNext || false,
      cursor: data.cursor,
      error
    };
  });
};